import { createStore } from 'vuex'
import app from '@/store/modules/app'
import auth from '@/store/modules/auth'
import controlPanel from '@/store/modules/controlPanel'
import user from '@/store/modules/user'

export default createStore({
  modules: {
    app,
    auth,
    controlPanel,
    user
  },
  strict: false
})
